import React from "react";
import "./PendingAmendmentFormLogDetails.css";

import { Dialog, DialogContent, DialogTitle, TextField } from "@mui/material";

import { convertToPSTWithSeconds } from "../../../../constants/dateTime";

const notApplicable = "N/A";

const displayValue = (value) => {
	if (value === null || value === undefined || value === "") return notApplicable;
	return value;
};

const displayDate = (value) => {
	if (!value) return notApplicable;
	return convertToPSTWithSeconds(value);
};

const PendingAmendmentFormLogDetails = (props) => {
	const r = props.recordToView ?? {};

	const formClosed = () => {
		props.setOpen(false);
	};

	return (
		<Dialog
			id="pendingAmendmentFormLogDetailsDialog"
			open={props.open}
			fullWidth
			maxWidth="lg"
			onClose={formClosed}
		>
			<DialogTitle id="pendingAmendmentFormLogDetailsDialogTitle">
				Pending Amendment Form Log Details
			</DialogTitle>
			<DialogContent id="pendingAmendmentFormLogDetailsDialogContent">
				<div className="pendingAmendmentFormLogDetailsDialogRow">
					<TextField
						sx={{ flex: 1 }}
						label="Log ID"
						value={displayValue(r.id)}
						InputProps={{ readOnly: true }}
					/>
					<TextField
						sx={{ flex: 1 }}
						label="Action Type"
						value={displayValue(r.action_type)}
						InputProps={{ readOnly: true }}
					/>
					<TextField
						sx={{ flex: 1 }}
						label="Action Status"
						value={displayValue(r.action_status)}
						InputProps={{ readOnly: true }}
					/>
				</div>
				<div className="pendingAmendmentFormLogDetailsDialogRow">
					<TextField
						sx={{ flex: 1 }}
						label="Action Clicked"
						value={displayDate(r.action_clicked_time)}
						InputProps={{ readOnly: true }}
					/>
					<TextField
						sx={{ flex: 1 }}
						label="Action Completed"
						value={displayDate(r.action_completed_time)}
						InputProps={{ readOnly: true }}
					/>
					<TextField
						sx={{ flex: 1 }}
						label="Submitted By"
						value={displayValue(
							r.submitted_by_employee_name ||
								r.submitted_by_employee_name_lookup
						)}
						InputProps={{ readOnly: true }}
					/>
				</div>
				<div className="pendingAmendmentFormLogDetailsDialogRow">
					<TextField
						sx={{ flex: 1 }}
						label="Pending Amendment ID"
						value={displayValue(r.pending_amendment_id)}
						InputProps={{ readOnly: true }}
					/>
					<TextField
						sx={{ flex: 2 }}
						label="HubSpot Deal Name"
						value={displayValue(r.hubspot_deal_name)}
						InputProps={{ readOnly: true }}
					/>
					<TextField
						sx={{ flex: 1 }}
						label="HubSpot Deal ID"
						value={displayValue(r.hubspot_deal_id)}
						InputProps={{ readOnly: true }}
					/>
				</div>
				<div className="pendingAmendmentFormLogDetailsDialogRow">
					<TextField
						sx={{ flex: 1 }}
						label="Property ID"
						value={displayValue(r.property_id)}
						InputProps={{ readOnly: true }}
					/>
					<TextField
						sx={{ flex: 1 }}
						label="Project ID"
						value={displayValue(r.project_id)}
						InputProps={{ readOnly: true }}
					/>
					<TextField
						sx={{ flex: 1 }}
						label="Contract Amount Pre-Submission"
						value={displayValue(r.contract_amount_pre_submission)}
						InputProps={{ readOnly: true }}
					/>
					<TextField
						sx={{ flex: 1 }}
						label="Adjustment Amount"
						value={displayValue(r.adjustment_amount)}
						InputProps={{ readOnly: true }}
					/>
				</div>
				<div className="pendingAmendmentFormLogDetailsDialogRow">
					<TextField
						sx={{ flex: 1 }}
						label="BQE Property ID"
						value={displayValue(r.bqe_property_id)}
						InputProps={{ readOnly: true }}
					/>
					<TextField
						sx={{ flex: 1 }}
						label="BQE Project ID"
						value={displayValue(r.bqe_project_id)}
						InputProps={{ readOnly: true }}
					/>
					<TextField
						sx={{ flex: 1 }}
						label="Is T&M"
						value={displayValue(r.is_time_and_materials)}
						InputProps={{ readOnly: true }}
					/>
				</div>
				<div className="pendingAmendmentFormLogDetailsDialogRow">
					<TextField
						sx={{ flex: 1 }}
						label="New Phase Created"
						value={displayValue(r.new_phase_created)}
						InputProps={{ readOnly: true }}
					/>
					<TextField
						sx={{ flex: 1 }}
						label="Contract Amount Adjusted"
						value={displayValue(r.contract_amount_adjusted)}
						InputProps={{ readOnly: true }}
					/>
				</div>
				<div className="pendingAmendmentFormLogDetailsDialogRow">
					<TextField
						sx={{ flex: 1 }}
						label="Error Message"
						value={displayValue(r.error_message)}
						InputProps={{ readOnly: true }}
					/>
				</div>
				<div className="pendingAmendmentFormLogDetailsDialogRow">
					<TextField
						sx={{ flex: 1 }}
						label="Payload JSON"
						value={displayValue(r.payload_json)}
						multiline
						minRows={10}
						InputProps={{ readOnly: true }}
					/>
				</div>
			</DialogContent>
		</Dialog>
	);
};

export default PendingAmendmentFormLogDetails;
